<template>
    <div class="modal modal-custom fade" :id="id">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <p v-text="targetStatus.msg"></p>
                </div>
                <div class="modal-footer row">
                    <div class="col-xs-6 right" v-if="!isSingleBtn">
                        <button type="button"
                            class="btn btn-default btn-block"
                            @click="cancel" v-text="cancelBtnText"></button>
                    </div>
                    <div class="col-xs-6 left" v-if="!isSingleBtn">
                        <button type="button"
                            class="btn btn-success btn-block"
                            @click="submit"
                            v-text="submitBtnText"></button>
                    </div>
                    <div class="col-xs-12" v-if="isSingleBtn">
                        <button type="button"
                            class="btn btn-success btn-block"
                            @click="submit"
                            v-text="submitBtnText"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
    props: {
        // modal ID
        id: {
            type: String,
            default: 'statusAlertModal',
        },
        // 開關控制 true: 開, false: 關
        triggerOpen: {
            type: Boolean,
            default: false,
        },
        // submit按鈕文字
        submitBtnText: {
            type: String,
            default: '確認',
        },
        // cancel按鈕文字
        cancelBtnText: {
            type: String,
            default: '取消',
        },
        // 是否僅顯示submit按鈕
        isSingleBtn: {
            type: Boolean,
            default: true,
        },
        // 是否客制取消按鈕：接受emit cancel
        isCustomCancel: {
            type: Boolean,
            default: false,
        },
        // status code
        statusCode: {
            type: Number,
            required: true,
        },
        // status 相關狀態資料
        statusData: {
            type: Array,
            default: () => [
                // notFound
                {
                    code: 404,
                    url: '',
                    msg: '目前找不到這個API，請利用導覽列進行其他頁面瀏覽。',
                    callback: null,
                },
                // serverError
                {
                    code: 500,
                    url: '/',
                    msg: '伺服器目前有誤，是否自動回首頁？',
                    callback: null,
                },
            ],
        },
    },
    data() {
        return {};
    },
    computed: {
        // 當前的status狀態
        targetStatus() {
            const vm = this;
            const defaultStatus = {
                code: null,
                url: '',
                msg: '',
                callback: null,
            };
            if (this.statusCode) {
                const tArr = this.statusData.filter(el => el.code === vm.statusCode);
                return tArr.length ? tArr[0] : defaultStatus;
            }
            return defaultStatus;
        },
    },
    mounted() {
    },
    methods: {
        /**
         * toggle modal
         */
        toggleAlertModal() {
            const vm = this;
            $(`#${vm.id}`).modal('toggle');
        },
        /**
         * submit method
         */
        submit() {
            this.toggleAlertModal();
            if (this.targetStatus.url) {
                window.location.href = this.targetStatus.url;
            }
            if (this.targetStatus.callback) {
                this.targetStatus.callback();
            }
        },
        /**
         * cancel method
         */
        cancel() {
            if (this.isCustomCancel) {
                this.$emit('oncancel');
            } else {
                this.toggleAlertModal();
            }
        },
    },
    watch: {
        triggerOpen() {
            this.toggleAlertModal();
        },
    },
};
</script>

<style>
    .modal-custom .modal-dialog {
        margin-top: 25vh;
        margin-left: auto;
        margin-right: auto;
        max-width: 400px
    }

    .modal-custom .modal-content {
        border: none;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
        padding: 1em;
    }

    .modal-custom .modal-content p {
        color: #5e5e5e;
        line-height: 1.4;
    }

    .modal-custom .modal-footer {
        border-top: none;
    }

    .modal-custom .modal-footer .col-xs-6.left {
        padding-right: 6px;
    }

    .modal-custom .modal-footer .col-xs-6.right {
        padding-left: 6px;
    }
</style>
